import { render } from "./Standings.vue?vue&type=template&id=3e8a5324&scoped=true"
import script from "./Standings.vue?vue&type=script&lang=js"
export * from "./Standings.vue?vue&type=script&lang=js"

import "./Standings.vue?vue&type=style&index=0&id=3e8a5324&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8a5324"]])

export default __exports__